import { createActions, createReducer } from 'reduxsauce'

import { AuthenticationTypes } from '../authentication/duckAuthentication'

/* Initial State */
const INITIAL_STATE = {
  error: null
}

/**
 * Creating actions and types with reduxsauce.
 */
const { Types, Creators } = createActions({
  saveBreeder: ['breeder', 'onSuccess', 'onError'],
  saveCultivar: ['cultivar', 'onSuccess', 'onError'],
  removeCultivar: ['cultivar', 'onSuccess', 'onError'],
  cultivarError: ['error']
})

const saveBreeder = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const saveCultivar = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const removeCultivar = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const cultivarError = (state = INITIAL_STATE, { error }) => ({
  ...state,
  error
})

const logout = () => ({ ...INITIAL_STATE })


/**
 * Creating reducer with Types.
 */
export default createReducer(INITIAL_STATE, {
  [Types.CULTIVAR_ERROR]: cultivarError,

  [Types.SAVE_BREEDER]: saveBreeder,

  [Types.SAVE_CULTIVAR]: saveCultivar,
  [Types.REMOVE_CULTIVAR]: removeCultivar,

  [AuthenticationTypes.LOGOUT]: logout
})

export {
  Types as CultivarTypes,
  Creators as CultivarActions
}
